/* ================================================================
   LF COLOR MODE — Design Checkpoint 1 (B2)
   ----------------------------------------------------------------
   Three modes: default | bw | lfj
   Mode stored in localStorage('lf-color-mode').

   FOUC prevention runs as an inline script in <head> (theme.liquid)
   — it reads localStorage and sets data-color-mode on <html> before
   any CSS renders. This file handles everything that runs at
   DOMContentLoaded: toggle wiring, LFJ color cycling, label sync.

   LFJ CYCLING: every 500ms, five custom properties on <html> step
   through the palette. CSS variables (--lf-c-a/b/c/d/e) are read by
   lf-color-mode.css and automatically applied to accent colors,
   glow effects, console brand text, and the toggle button itself.
   Using CSS custom properties means JS only needs to update one
   place — everything that reads those vars updates instantly.
================================================================ */
(function () {
  'use strict';

  var STORAGE_KEY  = 'lf-color-mode';
  var MODES        = ['default', 'bw', 'lfj'];
  var PALETTE      = ['#FF2D78', '#00FFD1', '#FFE600', '#BF00FF', '#39FF14'];
  var LABELS       = { default: 'MODE: DEFAULT', bw: 'MODE: B&W', lfj: 'MODE: LFJ \u2605' };

  var _interval    = null;
  var _step        = 0;

  /* ── Apply mode to <html> ── */
  function applyMode(mode) {
    var html = document.documentElement;
    if (mode === 'default') {
      html.removeAttribute('data-color-mode');
    } else {
      html.setAttribute('data-color-mode', mode);
    }
    _updateLabel(mode);
    if (mode === 'lfj') {
      _startCycle();
    } else {
      _stopCycle();
    }
  }

  /* ── LFJ color cycling ── */
  function _startCycle() {
    if (_interval) return; /* already running */
    /* Fire once immediately so first frame is already updated */
    _tick();
    _interval = setInterval(_tick, 500);
  }

  function _stopCycle() {
    if (_interval) { clearInterval(_interval); _interval = null; }
    /* Remove inline style vars — CSS fallbacks take over */
    var html = document.documentElement;
    html.style.removeProperty('--lf-c-a');
    html.style.removeProperty('--lf-c-b');
    html.style.removeProperty('--lf-c-c');
    html.style.removeProperty('--lf-c-d');
    html.style.removeProperty('--lf-c-e');
  }

  function _tick() {
    _step = (_step + 1) % PALETTE.length;
    var html = document.documentElement;
    /* Offset each var by one palette step so the five vars are always
       different colors simultaneously — creates the multi-color effect
       on elements that each bind a different var. */
    html.style.setProperty('--lf-c-a', PALETTE[ _step                         % PALETTE.length]);
    html.style.setProperty('--lf-c-b', PALETTE[(_step + 1) % PALETTE.length]);
    html.style.setProperty('--lf-c-c', PALETTE[(_step + 2) % PALETTE.length]);
    html.style.setProperty('--lf-c-d', PALETTE[(_step + 3) % PALETTE.length]);
    html.style.setProperty('--lf-c-e', PALETTE[(_step + 4) % PALETTE.length]);
  }

  /* ── Toggle button label ── */
  function _updateLabel(mode) {
    var btn = document.getElementById('lf-mode-toggle-btn');
    if (!btn) return;
    var label = LABELS[mode] || LABELS['default'];
    btn.textContent = label;
    btn.setAttribute('aria-label', 'Switch color mode. Current: ' + label);
  }

  /* ── Toggle on click — cycles default → bw → lfj → default ── */
  function _handleClick() {
    var current = document.documentElement.getAttribute('data-color-mode') || 'default';
    var idx     = MODES.indexOf(current);
    var next    = MODES[(idx + 1) % MODES.length];
    try { localStorage.setItem(STORAGE_KEY, next); } catch (e) { /* private mode */ }
    applyMode(next);
  }

  /* ── Init ── */
  function init() {
    var btn = document.getElementById('lf-mode-toggle-btn');
    if (!btn) return;

    btn.addEventListener('click', _handleClick);

    /* Sync label with whatever mode the FOUC script set on page load */
    var current = document.documentElement.getAttribute('data-color-mode') || 'default';
    _updateLabel(current);

    /* If page loaded already in LFJ mode (returning visitor), start cycling */
    if (current === 'lfj') _startCycle();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
